import { theme } from '_constants/theme';
import styled from 'styled-components';
import React from 'react';
import Input from '_components/atomic/Input';
import Button from '_components/atomic/Button';

const { colors, devices, fontSizes, spaces } = theme;

const StyledWhyTrademarkRight = styled.div`
  padding: ${spaces.large4X}px;
  gap: ${spaces.large2X - 2}px;
  background-color: ${colors.white};
  box-shadow: 0px 10px 80px rgba(0, 0, 0, 0.05);
  border-radius: 50px;
  display: flex;
  flex-direction: column;
  .headerRightTrademark {
    font-family: 'Aeonik';
    font-style: normal;
    font-weight: 400;
    font-size: ${fontSizes.large}px;
    line-height: 150%;
    text-align: justify;
    color: ${colors.gray[700]};
  }
  .listRightTrademark {
    width: 100%;
    gap: ${spaces.medium}px;
    display: flex;
    flex-direction: column;
  }
  @media ${devices.tablet} {
    border-radius: 0px;
    padding: ${spaces.regular}px;
    gap: ${spaces.regular}px;
    .headerRightTrademark {
      font-size: ${fontSizes.regular}px;
      text-align: left;
    }
    .listRightTrademark {
      background: ${colors.white};
    }
  }
`;
const ButtonsPanel = styled.div`
  display: flex;
  justify-content: end;
  gap: 30px;
`;
const RightPartWhyOfficeSection = () => {
  return (
    <StyledWhyTrademarkRight>
      <div className="headerRightTrademark">
        Enter your serial number in the search bar of the USPTO trademark status
        page:
      </div>
      <div className="listRightTrademark">
        <Input
          borderColor={theme.colors.gray[200]}
          textColor={theme.colors.gray[500]}
          color={theme.colors.white}
          hoverColor={theme.colors.white}
          hoverTextColor={theme.colors.gray[500]}
          placeholder="SERIAL NUMBER"
        />
      </div>
      <div className="headerRightTrademark">
        Within the documents section, select the &quot;Office Action&quot;
        document to review the issues brought forth by the UPSTO concerning your
        application.
      </div>
      <ButtonsPanel>
        <Button
          textColor={theme.colors.gray[300]}
          color={theme.colors.gray[400]}
        >
          Documents
        </Button>
        <Button textColor={theme.colors.white} color={theme.colors.blue[500]}>
          Status
        </Button>
      </ButtonsPanel>
    </StyledWhyTrademarkRight>
  );
};

export default RightPartWhyOfficeSection;
